import React from "react";
import "../css/ExcellenceSection.css";

const ExcellenceSection = () => {
  const randomImage = "/images/school03.jpg";

  return (
    <section className="excellence-container">
      <div className="excellence-content">
        {}
        <div className="excellence-text">
          <h2 className="excellence-title">
            Committed to Overall <br /> <span>Excellence</span>
          </h2>
          <p className="excellence-description">
            Our Goal: The central goal of Sahara Public School is the formation
            of Individual character as described in the following statement: A
            Human pursues spiritual goals through all his/her worldly
            endeavours. His/her behaviour embodies and reflects his morals and
            values. Pursuit of knowledge is among a student’s highest
            priorities, and a spirit of inquiry is the prerequisite. Faith and
            action work together to lead a student toward higher knowledge and
            progress, sound individual life choices, and service to society. The
            school seeks to develop in our students the values which define a
            citizen: honesty, compassion, respect for self and others, pride in
            work, a commitment to justice, and acceptance of differences.
          </p>
        </div>

        {}
        <div className="excellence-image-wrapper">
          <div className="dashed-border-box"></div>
          <img src={randomImage} alt="Excellence" className="excellence-img" />
        </div>
      </div>
    </section>
  );
};

export default ExcellenceSection;
